import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
// PropTypes para validación

// RadioGroup reutilizable
const RadioGroupField = React.memo(({
    label,
    value,
    onChange,
    options,
    disabled = false,
    name
}) => (
    <FormControl disabled={disabled}>
        <FormLabel id={`radio-group-${name}`}>{label}</FormLabel>
        <RadioGroup
            aria-labelledby={`radio-group-${name}`}
            name={name}
            value={value}
            onChange={onChange}
        >
            {options.map(({ value: optionValue, label: optionLabel }) => (
                <FormControlLabel
                    key={optionValue}
                    value={optionValue}
                    control={<Radio />}
                    label={optionLabel}
                />
            ))}
        </RadioGroup>
    </FormControl>
));

export default RadioGroupField;
RadioGroupField.displayName = 'RadioGroupField';